import { areaSearchCheck, footerNavAction } from '@/js/components/common'
import SmoothScroll from 'smooth-scroll'
import Analytics from 'analytics'
import googleTagManager from '@analytics/google-tag-manager'

const main = () => {
    let gtm_id,analytics

    if (document.querySelector('meta[name="gtm_id"]')) {
        gtm_id = document.querySelector('meta[name="gtm_id"]').getAttribute('content')
        analytics = Analytics({
            app: 'nuuun',
            plugins: [
                googleTagManager({
                    containerId: gtm_id
                })
            ]
        })
    }

    document.querySelector('#main-header .btn-menu').addEventListener('click', e => {
        let obj = document.querySelector('header .global-menu')
        if (obj.classList.contains('open')) {
            obj.classList.remove('open')
        } else {
            obj.classList.add('open')
        }
    })

    document.querySelector('#main-header .btn-search').addEventListener('click', e => {
        let obj = document.querySelector('header .article-search')
        if (obj.classList.contains('open')) {
            obj.classList.remove('open')
        } else {
            obj.classList.add('open')
        }
    })

    document.querySelectorAll('#main-header .close').forEach(_obj => {
        _obj.addEventListener('click', e => {
            _obj.parentNode.classList.remove('open')
        })
    })

    /*
    let match
    if(match = location.pathname.match(/^\/article\/category\/(.+)$/)){
        console.log(match)
        //document.querySelector('#main-header .categories').
    }
    */

    // カテゴリーのスクロール設定
    let targetTab = $(`#main-header .categories a[href="${location.pathname}"]`).parent()
    targetTab.addClass('active')
    if (targetTab.length) {
        setTimeout(() => {
            let catW = $('#main-header .categories').width()
            let pos = targetTab.position().left
            if (catW / 2 < pos) {
                $('#main-header .categories').scrollLeft(600)
            }
        }, 2000)
    }

    $('nav.global-menu .logout a').on('click', () => {
        $('#logout-form').submit()
        return false
    })

    const header = document.querySelector('#main-header');
    const fixedBound = 85;
    let pos = 0;
    window.addEventListener("scroll", () => {
        const headerState = header.classList.contains("fixed");
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > fixedBound) {
            if (!headerState) {
                header.classList.add("fixed");
            }
            if (pos > scrollTop) {
                header.classList.add("show");
            } else {
                header.classList.remove("show");
            }
        } else {
            if (headerState) {
                header.classList.remove("fixed");
            }
        }
        pos = scrollTop;
    });

    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300,//スクロールする速さ
        header: '#main-header'//固定ヘッダーがある場合
    });

    areaSearchCheck()
    footerNavAction()
}

export default main;
